function tournamentSeasons_Reducer(state = [], action) {
    switch (action.type) {
        case 'TOURNAMENT_SEASONS/SET':
            return action.tournament_seasons;
        case 'TOURNAMENT_SEASONS/CLEAR':
            return null;
        default:
            return state;
    }
}

export default tournamentSeasons_Reducer;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/tournamentSeasons.js